/**
 * 盲测会话占位（10-21 A1）：评测报告、评测记录批次报告、试跑详情 ／ 轨迹抽屉、运行记录里属于盲测 ／ 留出集的会话，
 * 接口层已不给题面、客户原话、对话和金标（判定见后端 `api/signal.is_sealed_turn`），页面统一写这一句。
 * 与题库快照页「盲测题，题面不公开」同一口径：只看题号与统计。
 */
import { Lock } from "lucide-react";

import { EmptyState } from "@/components/ui/feedback";

export const SEALED_CONTENT_TEXT = "盲测题，内容不展示";

export function SealedNotice({ desc, testId }: { desc?: string; testId?: string }) {
	return (
		<div data-testid={testId ?? "plan-sealed-notice"}>
			<EmptyState
				icon={<Lock className="h-6 w-6" />}
				title={SEALED_CONTENT_TEXT}
				desc={desc ?? "盲测 ／ 留出题只用来验证，不作开发调参；后台只给题号、结论、耗时与花费。"}
			/>
		</div>
	);
}
